// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Approximate color palette inspired by https://union.co/work */
  --union-dark: #07132b;    /* deep navy background */
  --union-mid:  #0b5fa8;    /* ocean/brand blue */
  --union-accent:#00b4d8;   /* bright cyan accent */
  --union-pale: #e8fbff;    /* very pale blue / background */
  --page-bg: #f5f5f5;      /* page background / grey banner color */

  --text-dark: #0b1b33;
  --text-on-dark: #ffffff;

  /* Legacy aliases (keeps older CSS that referenced these names working) */
  --dark-blue: var(--union-dark);
  --ocean-blue: var(--union-mid);
  --soft-cyan: var(--union-accent);
  --pale-blue: var(--union-pale);
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* Use the same grey as the sidebar/banner background for the overall page */
  background-color: var(--page-bg);
  color: var(--text-dark);
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Layout: central content area and white card sections to reveal background around them */
.SiteContent {
  /* allow sections to expand to the full viewport width (we'll offset each section)
     so the left edge can sit flush to the sidebar while keeping right breathing room */
  width: 100%;
  max-width: none;
  margin: 24px 0; /* reduced vertical breathing room so grey borders are thinner */
  padding: 0;
}

.PageSection {
  background: #fff;
  border-radius: 0; /* sharp corners */
  padding: clamp(16px, 2.5vw, 36px); /* slightly reduced inner padding */
  box-shadow: none; /* remove soft shadow */
  /* push the left edge flush to the nav (collapsed width) and keep a smaller right gutter so grey is subtler */
  margin: 0 24px 20px 0px; /* top/right/bottom/left */
}

/* Make Work and Metrics sections match the page background so they visually blend with the site */
#work.PageSection,
#metrics.PageSection {
  background: var(--page-bg);
  border-radius: 12px; /* rounded edges for these page sections */
  overflow: hidden; /* ensure children don't bleed outside rounded corners */
}

/* Modifier for PageSections that should use a dark background and light text */
.PageSection--dark {
  background: #000;
  color: #fff;
}

/* Partners section variant: dark bluish-grey background that spans the whole PageSection */
.PageSection--partners {
  background: #2b2f33;
  color: #fff;
  /* match the vertical spacing used previously in .Partners and keep the site's
     horizontal padding behavior for PageSections */
  padding: 56px clamp(16px, 2.5vw, 36px);
}

/* PageSection variant used for two-column split layouts where inner panes
   should control their own padding/backgrounds (removes the default padding)
   Example: MeetTheTeam uses this so the left column can render solid black
   without a white padding border. */
.PageSection--split {
  padding: 0;
}

/* Make the final footer/contact PageSection have a black background and white text */
footer.PageSection {
  background: #000;
  color: #fff;
}

.PageSection:last-child {
  margin-bottom: 36px; /* extra bottom breathing room */
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,gEAAgE;EAChE,qBAAqB,KAAK,yBAAyB;EACnD,qBAAqB,KAAK,qBAAqB;EAC/C,sBAAsB,IAAI,uBAAuB;EACjD,qBAAqB,KAAK,gCAAgC;EAC1D,kBAAkB,OAAO,wCAAwC;;EAEjE,oBAAoB;EACpB,uBAAuB;;EAEvB,yEAAyE;EACzE,8BAA8B;EAC9B,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,4EAA4E;EAC5E,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE;aACW;AACb;;AAEA,0FAA0F;AAC1F;EACE;uFACqF;EACrF,WAAW;EACX,eAAe;EACf,cAAc,EAAE,gEAAgE;EAChF,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB,EAAE,kBAAkB;EACpC,iCAAiC,EAAE,mCAAmC;EACtE,gBAAgB,EAAE,uBAAuB;EACzC,6GAA6G;EAC7G,uBAAuB,EAAE,0BAA0B;AACrD;;AAEA,kGAAkG;AAClG;;EAEE,0BAA0B;EAC1B,mBAAmB,EAAE,0CAA0C;EAC/D,gBAAgB,EAAE,wDAAwD;AAC5E;;AAEA,+EAA+E;AAC/E;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,2FAA2F;AAC3F;EACE,mBAAmB;EACnB,WAAW;EACX;mDACiD;EACjD,sCAAsC;AACxC;;AAEA;;;oCAGoC;AACpC;EACE,UAAU;AACZ;;AAEA,qFAAqF;AACrF;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB,EAAE,gCAAgC;AACvD","sourcesContent":[":root {\n  /* Approximate color palette inspired by https://union.co/work */\n  --union-dark: #07132b;    /* deep navy background */\n  --union-mid:  #0b5fa8;    /* ocean/brand blue */\n  --union-accent:#00b4d8;   /* bright cyan accent */\n  --union-pale: #e8fbff;    /* very pale blue / background */\n  --page-bg: #f5f5f5;      /* page background / grey banner color */\n\n  --text-dark: #0b1b33;\n  --text-on-dark: #ffffff;\n\n  /* Legacy aliases (keeps older CSS that referenced these names working) */\n  --dark-blue: var(--union-dark);\n  --ocean-blue: var(--union-mid);\n  --soft-cyan: var(--union-accent);\n  --pale-blue: var(--union-pale);\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  /* Use the same grey as the sidebar/banner background for the overall page */\n  background-color: var(--page-bg);\n  color: var(--text-dark);\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Layout: central content area and white card sections to reveal background around them */\n.SiteContent {\n  /* allow sections to expand to the full viewport width (we'll offset each section)\n     so the left edge can sit flush to the sidebar while keeping right breathing room */\n  width: 100%;\n  max-width: none;\n  margin: 24px 0; /* reduced vertical breathing room so grey borders are thinner */\n  padding: 0;\n}\n\n.PageSection {\n  background: #fff;\n  border-radius: 0; /* sharp corners */\n  padding: clamp(16px, 2.5vw, 36px); /* slightly reduced inner padding */\n  box-shadow: none; /* remove soft shadow */\n  /* push the left edge flush to the nav (collapsed width) and keep a smaller right gutter so grey is subtler */\n  margin: 0 24px 20px 0px; /* top/right/bottom/left */\n}\n\n/* Make Work and Metrics sections match the page background so they visually blend with the site */\n#work.PageSection,\n#metrics.PageSection {\n  background: var(--page-bg);\n  border-radius: 12px; /* rounded edges for these page sections */\n  overflow: hidden; /* ensure children don't bleed outside rounded corners */\n}\n\n/* Modifier for PageSections that should use a dark background and light text */\n.PageSection--dark {\n  background: #000;\n  color: #fff;\n}\n\n/* Partners section variant: dark bluish-grey background that spans the whole PageSection */\n.PageSection--partners {\n  background: #2b2f33;\n  color: #fff;\n  /* match the vertical spacing used previously in .Partners and keep the site's\n     horizontal padding behavior for PageSections */\n  padding: 56px clamp(16px, 2.5vw, 36px);\n}\n\n/* PageSection variant used for two-column split layouts where inner panes\n   should control their own padding/backgrounds (removes the default padding)\n   Example: MeetTheTeam uses this so the left column can render solid black\n   without a white padding border. */\n.PageSection--split {\n  padding: 0;\n}\n\n/* Make the final footer/contact PageSection have a black background and white text */\nfooter.PageSection {\n  background: #000;\n  color: #fff;\n}\n\n.PageSection:last-child {\n  margin-bottom: 36px; /* extra bottom breathing room */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
